module.exports = "/packs/images/homepage/activity/performing_arts_tablet~9a6cf201acbb4349311907e14ef40e4a.jpg";